import { type DeviceAdapter } from './DeviceAdapter';
import { usePlatform } from '../PlatformContext';

export const useDevice = (): DeviceAdapter => usePlatform().device;
